import { render, staticRenderFns } from "./edit-code-dialog.vue?vue&type=template&id=08fd9b6d&scoped=true&"
import script from "./edit-code-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-code-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fd9b6d",
  null
  
)

export default component.exports